var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{attrs:{"icon":"mdi-circle-edit-outline","tooltip-text":_vm.$t('ChangePassword')},on:{"click":_vm.redirectToChangePasswordForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }